<template>
  <modal :closeable="true" @abort="closeModal">
    <template>
      <h3>{{ $t('titles.change_payment') }}</h3>
    </template>
    <template>
      <template>
        <div class="header-with-border mt-1">
          <h4 class="uppercase">{{ $t('titles.new_payment_details') }}</h4>
        </div>
        <div class="payment-form form-row mobile-columns stripe-elements-container">
          <div v-if="stripeStatus=='loaded'">
            <div class="stripe-elements-wrapper">
              <StripeElements
                  :stripe-key="stripeKey"
                  :instance-options="instanceOptions"
                  :elements-options="elementsOptions"
                  #default="{ elements }"
                  ref="elms"
              >
                <StripeElement
                    type="card"
                    :elements="elements"
                    :options="cardOptions"
                    ref="card"
                />
              </StripeElements>
            </div>
            <div class="submit-container">
              <div v-if="paymentFailed" class="payment-error">
                <p class="small">{{ error }}</p>
              </div>
              <div class="payment-submit mt-2">
                <div class="button-wrapper">
                  <primary-button @click="pay" :disabled="formSubmitted" cta>{{ $t('buttons.save') }}</primary-button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </template>
    </template>
  </modal>
</template>

<script>
import Modal from '@/components/modal/ModalRegular.vue'
// import InputGroup       from '@/components/input/InputGroup.vue'
// import SecondaryButton    from '@/components/buttons/SecondaryButton.vue'
import {SET_IS_ERROR} from '@/store/mutationTypes'

import {StripeElement, StripeElements} from 'vue-stripe-elements-plus'
import PrimaryButton from "@/components/buttons/PrimaryButton";


export default {
  data() {
    return {
      stripeKey: process.env.STRIPE_PK, // test key, don't hardcode
      instanceOptions: {
        // https://stripe.com/docs/js/initializing#init_stripe_js-options
      },
      elementsOptions: {
        // https://stripe.com/docs/js/elements_object/create#stripe_elements-options
      },
      cardOptions: {
        // reactive
        // remember about Vue 2 reactivity limitations when dealing with options
        style: {
          base: {
            color: '#000',
            fontFamily: 'minion-pro, serif',
            fontSmoothing: 'antialiased',
            fontSize: '20px',
            '::placeholder': {
              color: '#5A5A5A'
            },
            padding: '10px 0 15px 0',
            lineHeight: '23px',
          },
          invalid: {
            color: '#F22613',
            iconColor: '#F22613'
          },
        },
        value: {
          postalCode: ''
        }
        // https://stripe.com/docs/stripe.js#element-options
      },
      error: null,
      token: null,
      formSubmitted: false,
    }
  },
  computed: {
    branch() {
      return process.env.FG_APP_BRANCH
    },
    paymentFailed() {
      return this.error != null;
    },
    stripeStatus() {
      return this.$store.getters.stripeStatus
    },
    currentUser () {
      return this.$store.getters.currentUser
    },
    membership() {
      return this.currentUser.membership
    },
    stripeInstance() {
      const groupComponent = this.$refs.elms
      return groupComponent.instance
    }
  },
  methods: {
    closeModal() {
      this.$router.push({path: '/'})
    },

    pay() {
      // ref in template
      const groupComponent = this.$refs.elms
      const cardComponent = this.$refs.card
      // Get stripe element
      const cardElement = cardComponent.stripeElement

      this.formSubmitted = true

      // Access instance methods, e.g. createToken()
      groupComponent.instance.createToken(cardElement).then(result => {
        if ('error' in result) {
          this.handleError(result.error)
        } else {
          this.handleToken(result.token)
        }
      })
    },

    handleToken(token) {
      this.token = token
      this.sendReq()
    },

    sendReq() {
      this.resetError();
      const params = {
        stripeToken: this.token && this.token.id,
        storeDiscount: 'default-discount',
        id: this.$store.getters.currentUser.membership.id,
      };

      this.$store.dispatch('updateMembership', params)
          // .then((response) => {
          .then(() => {
            this.tryHandleCardPayment();
          }, () => {
            this.formSubmitted = false
            this.$store.commit(SET_IS_ERROR, false)
          })
    },

    tryHandleCardPayment() {
      if (this.membership && this.membership.status == 'incomplete' && this.membership.stripeLastClientSecret) {
        // try to submit
        this.stripeInstance.handleCardPayment(this.membership.stripeLastClientSecret).then( (result) => {
          if (result.error) {
            this.error =  result.error.message;
            this.formSubmitted = false
          } else {
            this.$store.dispatch('completeMembership', {id: this.membership.id})
              // eslint-disable-next-line no-unused-vars
              .then((_response) => {
                this.$router.replace({path: '/success'})
              }).catch((err) => {
                this.formSubmitted = false
                this.error = err;
              })
          }
        }).catch(err => {
          this.formSubmitted = false
          this.error = err;
        });
      } else {
        this.formSubmitted = false
        this.$router.replace({path: '/'})
      }
    },

    handleError(error) {
      this.formSubmitted = false
      this.error = error.message;
    },

    resetError() {
      this.error = null;
    },
  },
  mounted() {
    // remove any former errors
    this.$store.commit(SET_IS_ERROR, false)

    if (this.stripeStatus == 'none') {
      this.$store.dispatch('loadStripeLib')
    }
  },
  watch: {
    stripeStatus: function (newValue) {
      if (newValue == 'loaded') {
        // this.createPaymentForm()
      }
    },
  },
  components: {
    PrimaryButton,
    Modal,
    StripeElements,
    StripeElement,
  }
}
</script>

<style lang="scss" scoped>
.text {
  margin: 15px 0;

  p {
    //font-family: $secondary-font-family;
    font-size: 1rem;
    color: #1F2429;
  }
}

.label {
  //font-size: 0.9375rem;
  color: $body-color;
  //font-weight: bold;
  //font-family: $secondary-font-family;
  margin-right: 20px;
}

.form-row.stripe-elements-container {
  margin-top: 30px - 8px;
}

.button-wrapper {
  display: flex;
  justify-content: flex-start;
  @media screen and (max-width: 750px) {
    justify-content: flex-end;
  }
}

.card-input {
  @media screen and (max-width: 750px) {
    flex: 1 1 100%;
  }
}


.submit-container {
  display: flex;
  flex-direction: column;

  .payment-error {
    flex: 1;
    margin-top: 30px - 8px;
    color: $error;
    text-align: left;
    //font-family: $secondary-font-family;

    //h4 {
    //  font-size: 1rem;
    //  font-weight: bold;
    //}

    h6 {
      font-size: 1rem;
      font-weight: normal;
    }

    @media screen and (max-width: 750px) {
      text-align: center;
      flex-direction: column;
    }
  }

  .payment-submit {
    text-align: right;
    width: 100%;

    .button-wrapper {
      justify-content: flex-end;
      margin: 0 auto;
      @media screen and (max-width: 750px) {
        justify-content: center;
      }
    }
  }

  @media screen and (max-width: 750px) {
    text-align: center;
    flex-direction: column;
  }
}

.sq-input {
  // height:38px
}

.stripe-elements-wrapper {
  border-bottom: 2px solid $border-color;
  padding: 10px 0 15px 0;
}

</style>

